import type { Configuration } from '@azure/msal-browser'

// Runtime config — the same OCI image runs in any environment.
// `window.__FUSION_CONFIG__` is set by /config.js (served by the backend
// before the main bundle loads); falling back to Vite's build-time env
// vars when running the SPA standalone via `npm run dev`.
declare global {
  interface Window {
    __FUSION_CONFIG__?: {
      entra?: { tenant?: string; clientId?: string; audience?: string }
    }
  }
}

const runtime  = window.__FUSION_CONFIG__?.entra ?? {}
const tenant   = runtime.tenant   || import.meta.env.VITE_ENTRA_TENANT   || ''
const clientId = runtime.clientId || import.meta.env.VITE_ENTRA_CLIENT_ID || ''
const audience = runtime.audience || import.meta.env.VITE_ENTRA_AUDIENCE || 'api://fusion-ii-console'

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenant || 'common'}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',  // Cleared on tab close; safer than localStorage for an admin tool.
    storeAuthStateInCookie: false,
  },
}

export const apiScopes: string[] = [`${audience}/access`]
